import type { RunMetricOutput } from "@/types/RunMetricOutput"

export const SingleSet = ({ mo }: { mo: RunMetricOutput }) => {
  const values = mo.set_value ?? []

  // Count occurrences of each value, then sort by count descending
  const countMap = values.reduce<Record<string, number>>((acc, val) => {
    acc[val] = (acc[val] ?? 0) + 1
    return acc
  }, {})
  const sorted = Object.entries(countMap).sort((a, b) => b[1] - a[1])

  const maxDisplay = 4
  const displayValues = sorted.slice(0, maxDisplay)

  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-2">
        {displayValues.map(([value]) => (
          <span
            key={value}
            className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-gray-100 text-gray-800"
          >
            {value}
          </span>
        ))}
      </div>
    </div>
  )
}
